import { SegmentEvent } from '@/integrations/segment/SegmentEvent';
import { BaseEventTracking } from '@/modules/core/app/models/abstracts/BaseEventTracking';

export class SelfServeSignupPageViewedEventTracking extends BaseEventTracking {
  static eventName: SegmentEvent = SegmentEvent.SELF_SERVE_SIGNUP_PAGE_VIEWED;
  email?: string;
  redirected_from?: string;

  constructor(eventProperties: Partial<SelfServeSignupPageViewedEventTracking> = {}) {
    super();
    this.email = eventProperties?.email;
    this.redirected_from = eventProperties?.redirected_from;
  }
}
